import React from "react";
import { useUserContext } from "../../../../contexts/User";
import { IconWithLabel, Link } from "../../../Actions";
import { DiscordBanner } from "../../../DiscordBanner/DiscordBanner";
import { StepContent } from "../Components";
import { links } from "@/utils/links";

const noInvites = (
  <>
    You didn&apos;t receive any invitations, but you&apos;re still playing a
    critical role in building the integrity of the Network. Please add{" "}
    <a
      className="underline text-coinage-blue inline"
      href="mailto:contact@trustless.media">
      contact@trustless.media
    </a>{" "}
    to your email contacts to avoid scams and spam filters, and keep an eye out
    for any updates from us.
  </>
);

const invites = (
  <>
    By inviting trusted people, you’re playing a critical role in building the
    integrity of the Network. Keep an eye out for any emails from us. We may
    redistribute unused invitations to you. And please add{" "}
    <a
      className="underline text-coinage-blue inline"
      href="mailto:contact@trustless.media">
      contact@trustless.media
    </a>{" "}
    to your contacts to avoid scams and spam filters.
  </>
);

const Thankyou: React.FC = () => {
  const { user } = useUserContext();

  return (
    <StepContent
      title="Thank you."
      description={user?.numInvites === 0 ? noInvites : invites}>
      <Link analyticsProperty="back to home" modifier="primary" href="/">
        <IconWithLabel label="Back to Home" icon="arrow" />
      </Link>
      <DiscordBanner>
        <div className="flex flex-col gap-2">
          <div className="flex flex-row gap-2 justify-between ">
            Join the Coinage Token-Gated Telegram Group
            <Link href={links.telegram} modifier="secondary">
              Telegram
            </Link>
          </div>
          <div className="flex flex-row gap-2">
            <span className="max-w-[40ch]">
              Use your NFT to become an official member with eligibility for
              patronage dividends.
            </span>
            <div>
              <Link href="/coop/onboarding" modifier="secondary">
                Join
              </Link>
            </div>
          </div>
        </div>
      </DiscordBanner>
    </StepContent>
  );
};

export default Thankyou;
